import { List, ListProps } from 'antd';
import React from 'react';
import { QMASCardLazyDocument } from '../item/CardDocument';

type ListDocumentProps = {
  listProps?: Partial<ListProps<string>>;
  dataSource: string[];
};

export const ListDocument = (props: ListDocumentProps) => {
  const { dataSource, listProps } = props;
  return (
    <List
      dataSource={dataSource}
      bordered={false}
      split={false}
      locale={{ emptyText: <></> }}
      renderItem={
        listProps?.renderItem
          ? listProps?.renderItem
          : (item, index) => {
              return (
                <List.Item key={index}>
                  <QMASCardLazyDocument documentId={item} />
                </List.Item>
              );
            }
      }
      {...listProps}
    />
  );
};
